@if (specificConfig.showLabel) {
	<h6>{{ specificConfig.label }}</h6>
}
<span>
	@for (checkbox of specificConfig.options; track $index) {
		<div class="form-check form-check-inline">
			<input
				(click)="onCheckboxToggle($event)"
				class="m-2"
				type="checkbox"
				id="genericCheckbox{{ $index }}"
				name="genericCheckbox"
				[value]="checkbox.primaryValue"
				[attr.secondaryValue]="checkbox.secondaryValue"
				[attr.checked]="this.status.selectedPrimaryValues.includes(checkbox.primaryValue) ? true : null" />
			<label for="genericCheckbox{{ $index }}">{{ checkbox.label }}</label>
		</div>
	}
</span>
